import React from 'react'

export function MegaphoneIcon({ size = 16, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M13 3 L13 11 L7 9 L7 5 Z" />
      <path d="M7 5 L3.5 5 C2.67 5 2 5.67 2 6.5 L2 7.5 C2 8.33 2.67 9 3.5 9 L7 9" />
      <path d="M5 9 L5 13 L7 13 L7 9" />
      <line x1="13" y1="7" x2="15" y2="7" />
    </svg>
  )
}
